import React from 'react'

const MenuIcon = ({className}) => (
  <svg version='1.1' viewBox='0 0 24 24' className={className}>
    <path d='M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z' />
  </svg>
)

export default MenuIcon
